import clsx from "clsx";

export const PlayerDropdownHeader = (props: {
    isLeaver: boolean;
    isBanned: boolean;
    isConnected: boolean;
    isLeader: boolean;
    playerName: string;
}) => {
    const { isLeader, isBanned, isConnected, isLeaver, playerName } = props;

    return (
        <li>
            <div className="d-flex align-items-center">
                <div className="dropdown-header d-flex gap-3">
                    <div className="flex-grow-1 d-flex align-items-center">
                        {isLeader ? (
                            <span className="fas fa-crown text-primary fs-5"></span>
                        ) : (
                            <span className="fas fa-user text-dark fs-5"></span>
                        )}
                    </div>

                    <div className="vstack">
                        <div className="fw-bold">{playerName}</div>
                        <small className={clsx(isLeaver || isBanned || !isConnected ? "text-danger" : "text-success")}>
                            {isBanned ? "Kicked" : isLeaver ? "Left game" : isConnected ? "Connected" : "Disconnected"}
                        </small>
                    </div>
                </div>
            </div>
        </li>
    );
};
